//@author: sara
import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { S25Durationfilter } from "../modules/s25-editable/s25-editable-duration/s25.durationfilter.service";
import { S25Datefilter } from "../modules/s25-dateformat/s25.datefilter.service";
import { DurationI } from "../pojo/DurationI";
import { Proto } from "../pojo/Proto";
import { S25Util } from "../util/s25-util";

@Pipe({
    name: "safeLink",
    standalone: false,
})
export class SafeLink implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {}
    transform(url: string): any {
        return this.sanitizer.bypassSecurityTrustUrl(url);
    }
}

//we should be able to add more @pipe classes here
@Pipe({
    name: "durationPipe",
    standalone: false,
})
export class DurationPipe implements PipeTransform {
    transform(duration: DurationI | Proto.ISODurationString): string {
        return S25Durationfilter.duration(duration);
    }
}

@Pipe({
    name: "SortBy",
    standalone: false,
})
export class SortByPipe implements PipeTransform {
    transform(values: Array<any>, args?: string) {
        return args === "ASC" ? values && values.sort() : values && values.sort().reverse();
    }
}

@Pipe({
    name: "dateFormat",
    standalone: false,
})
export class DateFormatPipe implements PipeTransform {
    transform(date: any, format?: string) {
        return S25Datefilter.transform(date, format);
    }
}

@Pipe({
    name: "timeFormat",
    standalone: false,
})
export class TimeFormatPipe implements PipeTransform {
    transform(date: any, format?: string) {
        return S25Datefilter.transform(date, format);
    }
}

// keeps HTML sanitizer from removing CSS from rich text editor contents
@Pipe({
    name: "safeHTML",
    pure: false,
    standalone: false,
})
export class HTMLPipe implements PipeTransform {
    constructor(protected _sanitizer: DomSanitizer) {}
    transform(items: any): SafeHtml {
        return this._sanitizer.bypassSecurityTrustHtml(items);
    }
}

@Pipe({
    name: "currency",
    standalone: false,
})
export class CurrencyFormatPipe implements PipeTransform {
    transform(number: number) {
        const formatter = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
        });

        return formatter.format(number);
    }
}

@Pipe({ name: "pluralS", standalone: true })
export class PluralSPipe implements PipeTransform {
    transform(message: string, count: number) {
        return count === 1 ? message : message + "s";
    }
}

@Pipe({ name: "ordinalSuffix", standalone: true })
export class OrdinalSuffixPipe implements PipeTransform {
    transform(num: number): string {
        return `${num}${S25Util.getOrdinalSuffix(num)}`;
    }
}
